import styled from 'styled-components';
import { BasicInputStyles } from './BasicInput';

type TextareaProps = {
  errorMessage?: string;
  required?: boolean;
  disabled?: boolean;
  inputSize?: string;
};

const Input = styled(BasicInputStyles)`
  height: 98px;
`;

const Textarea = ({
  errorMessage,
  required,
  disabled,
  inputSize = 'md'
}: TextareaProps) => {
  return (
    <Input
      inputSize={inputSize}
      required={required}
      disabled={disabled}
      errorMessage={errorMessage}
    />
  );
};

export { Textarea };
